import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/axios';
import type {
  Detection,
  DetectionFilters,
  PaginatedResponse,
} from '@/types/api';

// ── Query key factory ──────────────────────────────────────────────────────
export const detectionKeys = {
  all: ['detections'] as const,
  list: (filters: DetectionFilters) => [...detectionKeys.all, 'list', filters] as const,
  detail: (id: string) => [...detectionKeys.all, 'detail', id] as const,
};

// ── Hooks ─────────────────────────────────────────────────────────────────

export function useDetections(filters: DetectionFilters = {}) {
  return useQuery({
    queryKey: detectionKeys.list(filters),
    queryFn: async () => {
      const { data } = await apiClient.get<PaginatedResponse<Detection>>(
        '/detections',
        { params: filters },
      );
      return data;
    },
  });
}

export function useDetection(id: string) {
  return useQuery({
    queryKey: detectionKeys.detail(id),
    queryFn: async () => {
      const { data } = await apiClient.get<Detection>(`/detections/${id}`);
      return data;
    },
    enabled: Boolean(id),
  });
}
